import { render, staticRenderFns } from "./Akun.vue?vue&type=template&id=6f800d24&"
import script from "./Akun.vue?vue&type=script&lang=js&"
export * from "./Akun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports